import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import Nav from './layout/Nav.jsx';
import Footer from './layout/Footer.jsx';
import {
  PageAssignment,
  PageAssignments,
  PageDashboard,
  PageAnnouncements,
  PageAnnouncement,
  PageBadges,
  PageProfile,
  PageAvatarPicker,
  PageRankings,
  PageQa,
  PageViewSlot,
  PageReadingMissions,
  PageReadingMission,
  PageReadingHistory,
  PageReadingHistoryArticle,
} from './pages';
import ModalAnnouncement from './modals/ModalAnnouncement.jsx';
import PageReadingMissionsList from './pages/PageReadingMissionsList.jsx';
import ReadingList from './pages/ReadingList.jsx';

const App = () => (
  <div className="h-100">
    <Router>
      <ModalAnnouncement />
      <Nav />
      <div className="content">
        <div className="w-100">
          <Switch>
            <Route path="/app" exact>
              <PageDashboard />
            </Route>
                 <Route exact path="/app/missionsList/:assignmentId">
              <PageReadingMissionsList />
            </Route>
            <Route path="/app/missionList/:_id">
              <ReadingList />
            </Route>
            <Route exact path="/app/missions/:assignmentId">
              <PageReadingMissions />
            </Route>
            <Route path="/app/mission/:_id">
              <PageReadingMission />
            </Route>
            <Route exact path="/app/reading-history">
              <PageReadingHistory />
            </Route>
            <Route exact path="/app/reading-history/article/:_id">
              <PageReadingHistoryArticle />
            </Route>
            <Route exact path="/app/assignments">
              <PageAssignments />
            </Route>
            <Route path="/app/assignments/:date">
              <PageAssignment />
            </Route>
            <Route exact path="/app/announcements">
              <PageAnnouncements />
            </Route>
            <Route exact path="/app/announcements/:_id">
              <PageAnnouncement />
            </Route>
            <Route exact path="/app/profile">
              <PageProfile />
            </Route>
            <Route exact path="/app/profile/avatar">
              <PageAvatarPicker />
            </Route>
            <Route exact path="/app/profile/badges">
              <PageBadges />
            </Route>
            <Route exact path="/app/rankings">
              <PageRankings />
            </Route>
            <Route exact path="/app/qa">
              <PageQa />
            </Route>
            <Route path="*">
              <PageViewSlot />
            </Route>
          </Switch>
        </div>
      </div>
      <Footer />
    </Router>
  </div>
);

export default App;
